import BatchWorker from "./batch.worker";

export interface IBatchSchema {
  batchName: string;
  batchDescription: string;
  purpose: string;
  calculationMethod: string;
  preparer: string;
  preparedDate: Date;
  standardJE: Date;
  approver: string;
  approvedDate: Date;
  hashTotal: string | number;
  jeTotal: string | number;
  emptyLineItems: boolean;
}

export default BatchWorker;
